import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  StyledMain,
  StyledAccountForm,
  StyledAccountFormTitle,
  StyledAccountFormContent,
  StyledAccountFormBtnContent,
  StyledAccountFormInput,
  StyledAccountFormLabel,
  StyledButtonCancel
} from './style';
import Button from '../../../core/Buttons';

import { bankAccount } from '../../../../constants/user';

const {
  bankAccountForm: { title, label, errorMessage, btn }
} = bankAccount;

class BankAccountForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ibanCode: props.ibanCode,
      validAccount: props.validIbanCode
    };
  }

  handleOnSend = () => {
    const { onSend } = this.props;
    const { ibanCode } = this.state;
    const ibanCodeTrimmed = ibanCode.replace(/\s+/g, '');

    if (onSend) {
      onSend(ibanCodeTrimmed);
    }
  };

  render() {
    const { ibanCode, validAccount } = this.state;
    const { onBack } = this.props;

    return (
      <Fragment>
        <StyledAccountForm>
          <StyledAccountFormTitle>{title}</StyledAccountFormTitle>
          <StyledAccountFormContent>
            <StyledAccountFormLabel htmlFor="iban">
              {label}
            </StyledAccountFormLabel>
            <StyledAccountFormInput
              name="iban"
              id="iban"
              error={!validAccount ? errorMessage : false}
              value={ibanCode}
              valid
              onChange={ibanCode => this.setState({ ibanCode })}
            />
          </StyledAccountFormContent>
          <StyledAccountFormBtnContent>
            <StyledButtonCancel ghost dark onClick={onBack}>
              Cancelar
            </StyledButtonCancel>
            <Button
              secondary
              onClick={this.handleOnSend}
              disabled={!(ibanCode && ibanCode.length >= 24)}
            >
              {btn}
            </Button>
          </StyledAccountFormBtnContent>
        </StyledAccountForm>
      </Fragment>
    );
  }
}

const SectionWrapper = ({ children }) => <StyledMain>{children}</StyledMain>;

BankAccountForm.propTypes = {
  onSend: PropTypes.func,
  validIbanCode: PropTypes.bool
};

export { SectionWrapper, BankAccountForm };
